var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%","overflow":"hidden"}},[_c('iframe',{staticStyle:{"width":"100%","height":"100%","overflow":"hidden"},attrs:{"src":'/google-map.html?lat=' + _vm.lat + '&lng=' + _vm.lng},on:{"message":_vm.postMessageFun}})])
}
var staticRenderFns = []

export { render, staticRenderFns }